<template>
    <Drawer :class="classese" v-bind="$attrs" v-on="$listeners" :wrapperClosable="false">
        <template v-slot>
            <div :class="`${prefix}-content`">
                <slot />
            </div>

            <div :class="`${prefix}-footer`" v-if="$slots.footer">
                <slot name="footer" />
            </div>
        </template>
    </Drawer>
</template>
<script>
import { defineComponent } from '@vue/composition-api'
import { Drawer } from 'element-ui'

const prefix = 'u-drawer'

export default defineComponent({
    components: {
        Drawer
    },
    data() {
        return {
            prefix
        }
    },
    methods: {
    },
    computed: {
        classese() {
            return [prefix]
        }
    }
})
</script>

<style lang="scss">
$prefixCls: u-drawer;

.#{$prefixCls} {
    .el-drawer__header {
        border-bottom: 1px solid #efefef;
        margin-bottom: 0;
    }

    .el-drawer {
        .el-drawer__header {
            padding: 20px;
            padding-bottom: auto;

            span:focus {
                outline: none;
            }
        }

        &:focus {
            outline: none;
        }

        .el-drawer__body {
            display: flex;
            flex-direction: column;
            height: 1px;

            .#{$prefixCls}-content {
                flex: 1;
                overflow-y: auto;
            }

            .#{$prefixCls}-footer {
                padding: 16px 0;
                text-align: center;
                border-top: 1px solid #efefef;
            }
        }
    }
}
</style>
